import { useState, useCallback } from 'react';
import { checkFilesOnSite as checkFilesApi } from '../api';

export default function useFilesVerification(slug) {
    const [filesStatus, setFilesStatus] = useState({
        llm: { exists: false, checking: false, url: null },
        schema: { exists: false, checking: false, url: null }
    });

    const checkFilesOnSite = useCallback(async () => {
        if (!slug) return;

        setFilesStatus({
            llm: { exists: false, checking: true, url: null },
            schema: { exists: false, checking: true, url: null }
        });

        try {
            const data = await checkFilesApi(slug);
            setFilesStatus({
                llm: {
                    exists: data.llm?.exists ?? false,
                    checking: false,
                    url: data.llm?.url ?? null
                },
                schema: {
                    exists: data.schema_org?.exists ?? false,
                    checking: false,
                    url: data.schema_org?.url ?? null
                }
            });
        } catch {
            setFilesStatus({
                llm: { exists: false, checking: false, url: null },
                schema: { exists: false, checking: false, url: null }
            });
        }
    }, [slug]);

    return { filesStatus, checkFilesOnSite };
}
